/**
 * Returns the correct spreadsheet ID based on report's lock status
 * @param {Object} report - The report object
 * @param {string} defaultId - The default ID to use if no report is provided
 * @returns {string} The correct spreadsheet ID to use
 */
export const getEffectiveSpreadsheetId = (report, defaultId = null) => {
  if (!report) return defaultId;

  // If report is locked and has a locked spreadsheet ID, use that
  if (
    report.reportMetadata?.isLocked &&
    report.reportMetadata?.lockedSpreadsheetId
  ) {
    return report.reportMetadata.lockedSpreadsheetId;
  }

  // Otherwise use the original reportId
  return report.spreadsheetId || defaultId;
};

/**
 * Returns the correct spreadsheet URL based on report's lock status
 * @param {Object} report - The report object
 * @returns {string} The correct URL to the spreadsheet
 */
export const getEffectiveSpreadsheetUrl = (report) => {
  if (!report) return "";

  // If report is locked and has a locked URL, use that
  if (
    report.reportMetadata?.isLocked &&
    report.reportMetadata?.lockedSpreadsheetUrl
  ) {
    return report.reportMetadata.lockedSpreadsheetUrl;
  }

  // Otherwise use the original link
  return report.link || "";
};

/* New function that fixes an error we can try this later if we use it */
/*
export const getEffectiveSpreadsheetUrl = (report) => {
  if (!report) return "";

  // If report is locked and has a locked URL, use that
  if (
    report.reportMetadata?.isLocked &&
    report.reportMetadata?.lockedSpreadsheetUrl
  ) {
    return report.reportMetadata.lockedSpreadsheetUrl;
  }

  // Otherwise construct a URL from the reportId
  if (report.reportId) {
    return `https://docs.google.com/spreadsheets/d/${report.reportId}`;
  }
  
  // Fallback to report.link if present
  return report.link || "";
};
*/

/**
 * Returns information about whether to use vault/service account
 * for API operations on this report
 * @param {Object} report - The report object
 * @returns {boolean} True if vault/service account should be used
 */
export const shouldUseVaultAccount = (report) => {
  // Check if the report is locked (which means it's approved)
  return !!report?.reportMetadata?.isLocked;
};
